var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BasePayment",
    {
      attrs: {
        loading: _vm.loading,
        textHeader: _vm.$t("apps.payment.label.payserviceusagemonthly"),
        steps: _vm.progress.steps,
        active: _vm.progress.active,
        showBackButton: _vm.isShowBackButton
      }
    },
    [
      _vm.isChargeSuccess
        ? _c("Paid", {
            attrs: { transaction: _vm.transaction },
            on: { next: _vm.onPaidClickedNext }
          })
        : _c("PaymentFail", { on: { next: _vm.onPaymentFailClickedNext } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61f4d5fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61f4d5fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentpackage/CallbackAuth.vue
// module id = null
// module chunks = 